import { Product } from "../../classes";

const ProductModule = {
  namespaced: true,
  state: {
    product: []
  },
  actions: {
    getProducts: async ({ commit, rootGetters }, payload) => {
      try {
        const data = await Product.getProducts({
          projectId: payload.projectId
        });
        commit("setProduct", { product: data });
        return data;
      } catch (err) {
        throw err;
      }
    },
    createProduct: async ({ commit, rootGetters, dispatch }, payload) => {
      try {
        const data = await Product.createProduct({
          projectId: rootGetters["markets/getProjectId"],
          name: payload.name,
          name_en: payload.name_en,
          erpId: payload.erpId,
          productCategoryId: payload.productCategoryId
        });
        commit("addProduct" , data)
        return data;
      } catch (err) {
        throw err;
      }
    },
    updateProduct: async ({ commit, rootGetters, dispatch }, payload) => {
      try {
        const data = await Product.updateProduct({
          id: payload.id,
          name: payload.name,
          name_en: payload.name_en,
          erpId: payload.erpId,
          productCategoryId: payload.productCategoryId
        });
        commit("updateProduct" , data)
        return data;
      } catch (err) {

        throw err;
      }
    },
    removeProduct: async ({ commit }, id) => {
      try {
        const data = await Product.removeProduct(id)
        commit("removeProduct" , data)
        return data;
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {
    getProducts: state =>
      state.product.map(r => {
        const newPC = `${r.productCategory ? r.productCategory.erpId : "N/A"
          } - ${r.productCategory ? r.productCategory.name : "N/A"}/${r.productCategory ? r.productCategory.name_en : "N/A"
          }`;
        r.productCategoryLabel = newPC;
        r.form = ({ objectId: r.objectId, name: r.name })
        r.products_label = r.products ? r.products.join("_") : ""
        return r;
      }),
    getProductNameOnly: state => state.product.map(i => ({ objectId: i.objectId, name: i.name })),
    getProductTotal: state => state.product.length
  },
  mutations: {
    setProduct: (state, payload) => {
      state.product = payload.product;
    },
    removeProduct(state, product){
      if (state.product) {
        let index = state.product.findIndex(i => i.objectId === product.objectId);
        state.product.splice(index, 1);
      }
    },
    updateProduct: (state , product) => {
      let index = state.product.findIndex(i => i.objectId === product.objectId);
      if(index > -1){
        state.product[index] = product;
      }else{
        state.product.push(product)
      }
    },
    addProduct: (state, product) => {
      state.product.push(product);
    },
  }
};
export default ProductModule;
